import React from "react";
import {FaRegStar, FaStar, FaStarHalfAlt} from "react-icons/fa";

const DisplayStarRating = ({ rating }) => {
  const totalStars = 5;

  const renderStars = () => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating - fullStars >= 0.5;

    for (let i = 0; i < totalStars; i++) {
      if (i < fullStars) {
        stars.push(<FaStar key={i} className="filled-star" />);
      } else if (i === fullStars && hasHalfStar) {
        stars.push(<FaStarHalfAlt key={i} className="filled-star" />);
      } else {
        stars.push(<FaRegStar key={i} className="empty-star" />);
      }
    }

    return stars;
  };

  return <div className="star-ratings">{renderStars()}</div>;
};

export default DisplayStarRating;
